import React, { useState } from "react";
import { Input } from "reactstrap";
import { useSelector } from "react-redux";
import { addComment } from "../store/actions/discoverActions";
import { notifyError, notifySuccess, notifyInfo } from "../utils/notifyToast";

function Comments({ purchaseNumber, handleDetails }) {
  const [comment, setComment] = useState("");
  const { token, profileFetchStatus } = useSelector(({ authUser }) => ({
    token: authUser.uid,
  }));

  const onCommentSubmit = () => {
    if (!comment) {
      notifyInfo("Please add comment");
      return;
    }
    addComment(
      token,
      purchaseNumber,
      comment,
      (resp) => {
        notifySuccess(resp.msg);
        setComment("");
        handleDetails();
      },
      (err) => {
        notifyError(err.message || "Could not add Internal Notes.");
      }
    );
  };

  return (
    <div>
      <Input
        placeholder="comment"
        value={comment}
        onChange={(e) => {
          setComment(e.target.value);
        }}
        type="text"
        style={{ width: 400, marginTop: "1rem" }}
        required
      />
      <button className="header_menu__item mt-3 w-40" onClick={onCommentSubmit}>
        Add Comment
      </button>
    </div>
  );
}

export default Comments;
